import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetVehicleConfigurationRequest extends ValueObject {
  #vehicleId
  #zipcode
  #legalConditionsAccepted

  static validate({vehicleId, zipcode}) {
    if (!vehicleId || !zipcode) {
      throw InvalidParamsSharedError.create(
        `[GetVehicleConfigurationRequest.validate] param vehicleId and zipcode are required`
      )
    }
  }

  constructor({vehicleId, zipcode, legalConditionsAccepted}) {
    super()
    this.#vehicleId = vehicleId
    this.#zipcode = zipcode
    this.#legalConditionsAccepted = legalConditionsAccepted
  }

  static create({vehicleId, zipcode, legalConditionsAccepted = false}) {
    GetVehicleConfigurationRequest.validate({vehicleId, zipcode, legalConditionsAccepted})
    return new GetVehicleConfigurationRequest({
      vehicleId,
      zipcode,
      legalConditionsAccepted
    })
  }

  toJSON() {
    return {
      vehicleId: this.#vehicleId,
      zipcode: this.#zipcode,
      legalConditionsAccepted: this.#legalConditionsAccepted
    }
  }
}
